import { Flex, Text, Tooltip } from '@gazin/ecommerce-ui'
import GImage from 'src/components/gImage'
import { theme } from 'src/styles/themes/default'

type ProductAttributeColorProps = {
  available?: boolean
  image?: string
  value?: string
}

export default function ProductAttributeColor({
  available,
  image = '',
  value,
}: ProductAttributeColorProps) {
  const productImage = image.trim() || '/images/jpg/produto-default.jpg'

  return (
    <Tooltip label={value}>
      <Flex alignItems="center" flexDirection="column" padding="0.25rem">
        <GImage
          src={productImage}
          alt="Imagem da variação"
          width={70}
          height={70}
          style={{
            borderRadius: '0.313rem',
            zIndex: 1,
            opacity: available ? '1' : '0.5',
          }}
        />
        {!available && (
          <Flex
            alignItems="center"
            bgColor="#DCDDE3"
            borderBottomRadius="0.125rem"
            bottom="0"
            h="1rem"
            justifyContent="center"
            position="absolute"
            w="100%"
            zIndex="2"
          >
            <Text
              color={theme.colors.grey[200]}
              fontSize="0.5rem"
              lineHeight="0.75rem"
              mb="0"
            >
              Indisponível
            </Text>
          </Flex>
        )}
      </Flex>
    </Tooltip>
  )
}
